import { render, staticRenderFns } from "./SalesSummary.vue?vue&type=template&id=187cefd8&scoped=true"
import script from "./SalesSummary.vue?vue&type=script&lang=js"
export * from "./SalesSummary.vue?vue&type=script&lang=js"
import style0 from "./SalesSummary.vue?vue&type=style&index=0&id=187cefd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187cefd8",
  null
  
)

export default component.exports